import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

export class GGGameAssets {

    public static INTRO_BACKGROUND:string = "resources/images/intro/Intro_BG.jpg";
    public static MAIN_BACKGROUND:string = "resources/images/intro/Main_background.jpg";
    public static INTRO_LOGO:string = "resources/images/intro/introLogo.png";

    public static MAIN_GAME_BACKGROUND:string = GGGameAssets.MAIN_BACKGROUND;
    public static FS_GAME_BACKGROUND:string = "freespinBackground";

    public static WAYS:string = "textWays";

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(symbolName.indexOf("W") > -1 && (symbolName.length > 1)) {
            symbolName = "W3";
        }
        return symbolName + "/" + symbolName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(GGGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

public static getSymbolMStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {

        return GameResources.getTextures(symbolName);
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("evilMultiplier", "fonts/bitmapfonts/evilMultipliers/evilMultiplier.fnt"),
                    new BitmapFontAsset("EvilGoblins_countUp", "fonts/bitmapfonts/countup/EvilGoblins_countUp.fnt"),
                    new BitmapFontAsset("multiplierCountup", "fonts/bitmapfonts/multiplierCountUp/multiplier_countup-export.fnt"),
                    new BitmapFontAsset("ways", "fonts/bitmapfonts/ways/ways.fnt"),
                    new BitmapFontAsset("spinsMultiplier", "fonts/bitmapfonts/spinsMultiplier/multiplier-yellow.fnt")
                ]
            }
        ],
        main : [
            {
                //Reduce to 8-bit color
                name : "mainYellow",
                assets : [
                    new TextureAsset("mainYellow0", "sheets/mainYellow/mainYellow0.json"),
                    new TextureAsset("mainYellow1", "sheets/mainYellow/mainYellow1.json"),
                ],
                animations : {
                    "symExplosion" : "symExplosion/symExplosion_0",
                },
            },
            {
                //Reduce to 8-bit color
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
               ],
                animations : {
                    "reelFrameL" : "background/left-frame",
                    "reelFrameT" : "background/top-frame",
                    "reelFrameB" : "background/bottom-frame",
                    "reelFrameR" : "background/right-frame",
                    "outroWinSprite" : "Outro/Outro/Front_CH",
                    "portraitLogoSign" : "background/banner",
                    "torchEmpty" : "background/torch_empty",
                    "bombSmoke" : "X_bomb/Smoke_Reel_Xbomb/Reel_Smoke_",
                    "guaranteedDeadWild" : "GW",
                    "landing_L" : "Landing_L/Landing_L_",
                    "fsOutroCoin" : "Outro/Glod_Coin_Loop/Gold_Coin_Loop_",
                    "featureSignDoubleBomb" : "BuyFeature5",
                    "featureSign_landscape" : "featureSign/BonusSign&Spinsholder_landscape",
                    "featureSign_portrait" : "featureSign/BonusSign&Spinsholder_portrait",
                    "featureSign_x2bomb" : "featureSign/xbombx2",
                }
            },
            {
                //Reduce to 8-bit color
                name : "mainHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json")
                ],
                animations : {
                    "wildMeterClaw" : "wildMeter/hands_on_reel",
                    "waysWonBG" : "ways/waysWonBG",
                    "textWays" : "ways/text_Ways",
                    "waysWonText" : "ways/text_WaysWon",
                    "wayWonText" : "ways/text_WayWon",
                    "waysHolder" : "ways/ways_holder",
                    "multiplierHolder" : "multiplier/multiplier",
                    "W_bg" : "W/W_bg",
                    "W3_bg" : "W3/W3_bg",
                    "W_frame" : "W/W_frame",
                    "W3_frame" : "W3/W3_frame",
                    "W_cloth" : "W/W_cloth",
                    "W3_cloth" : "W3/W3_cloth",
                    "W_attention" : "W/W",
                }
            },
            {
                name : "bgJpeg",
                assets : [
                    new TextureAsset("bgJpeg0", "sheets/bgJpeg/bgJpeg0.json"),
                    new TextureAsset("bgJpeg1", "sheets/bgJpeg/bgJpeg1.json")
                ],
                animations : {
                    "reelBackground" : "Reel_background"
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                ],
                animations : {
                    "M_size7_bg" : "M_bg/77_m_bnw_bg",
                    "M_size6_bg" : "M_bg/90_m_bnw_bg",
                    "M_size5_bg" : "M_bg/108_m_bnw_bg",
                    "M_size4_bg" : "M_bg/136_m_bnw_bg",
                    "M_size3_bg" : "M_bg/181_m_bnw_bg",
                    "wildMeterActiveShine" : "Cloth_Shine_NW",
                    "coinShine" : "Particales",
                    "potentialGlowBox" : "winBox_01",
                    "potentialGlow" : "start_glow",
                    "reelFireIdle" : "reel_fire/reelFxLoop_",
                    "guaranteedDeadWildGlow" : "FS_DW_Attention/DW_FS_Attention_",
                    "landing_M" : "M_Symbol/Landing_Smoke/Landing_Smoke_",
                    "grenadeFire" :"GS_Trail/Gs_Trail_",
                }
            },
            {
                //Reduce to 8-bit color
                name : "freespin",
                assets : [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json"),
                    new TextureAsset("freespin1", "sheets/freespin/freespin1.json")
                ],
                animations : {
                    "plusOne" : "+1freespin",
                    "fsBGGolds" : "bg/golds",
                    "fsBGTop" : "bg/top",
                    "fsBGBone" : "bg/bone",
                    "fsBGBridge" : "bg/bridge",
                    "fsCounterFlag" : "Spins",
                    "fsBadge_normal" : "featureSign/freshmeatSpins",
                    "fsBadge_normal_bomb" : "featureSign/freshmeatSpins_explosive",
                    "fsBadge_super" : "featureSign/goblinFeastspins",
                    "fsBadge_super_bomb" : "featureSign/goblinFeastspins_explosive",
                    "fsBadge_random" : "featureSign/luckydraw",
                    "portraitLogoSign_FS" : "banner_fs"
                }
            },
            {
                name : "freespinJpeg",
                assets : [
                    new TextureAsset("freespinJpeg0", "sheets/freespinJpeg/freespinJpeg0.json"),
                ],
                animations : {
                    "freespinBackground" : "base",
                },
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("L1", "spine/L1.json"),
                    new SpineAsset("L2", "spine/L2.json"),
                    new SpineAsset("L3", "spine/L3.json"),
                    new SpineAsset("L4", "spine/L4.json"),
                    new SpineAsset("L5", "spine/L5.json"),
                    new SpineAsset("S", "spine/S_Animation.json"),
                    new SpineAsset("DW_GW", "spine/DW_GW.json"),
                    new SpineAsset("DW_Landing", "spine/DW_Landing.json"),
                    new SpineAsset("DW_NW", "spine/DW_NW.json"),
                    new SpineAsset("Outro_lose", "spine/Outro_lose.json"),
                    new SpineAsset("Outro_win", "spine/Outro_win.json"),
                    new SpineAsset("BG_Fire", "spine/BG_Fire.json"),
                    new SpineAsset("Outro_win_Coin", "spine/Outro_win_Coin.json"),
                    new SpineAsset("Outro_lose_Loop", "spine/Outro_lose_Loop.json"),
                    new SpineAsset("M1", "spine/M1.json"),
                    new SpineAsset("M2", "spine/M2.json"),
                    new SpineAsset("M3", "spine/M3.json"),
                    new SpineAsset("M4", "spine/M4.json"),
                    new SpineAsset("M5", "spine/M5.json"),
                    new SpineAsset("M1Explosion", "spine/M1_Explosion.json"),
                    new SpineAsset("M2Explosion", "spine/M2_Explosion.json"),
                    new SpineAsset("M3Explosion", "spine/M3_Explosion.json"),
                    new SpineAsset("M4Explosion", "spine/M4_Explosion.json"),
                    new SpineAsset("M5Explosion", "spine/M5_Explosion.json"),
                    new SpineAsset("M_To_NW", "spine/M_To_NW.json"),
                    new SpineAsset("B", "spine/XBomb.json"),

                    new SpineAsset("Potential_Win", "spine/Potential_Win.json"),
                    new SpineAsset("W", "spine/NW.json"),
                    new SpineAsset("W3", "spine/GW.json"),
                    new SpineAsset("Highlight", "spine/Highlight.json"),
                    new SpineAsset("Prince_FS", "spine/Prince_FS.json"),
                    new SpineAsset("BG_Shine", "spine/BG_Shine.json"),
                    new SpineAsset("FS_Elements", "spine/FS_Elements.json"),
                    new SpineAsset("FS_Cart", "spine/FS_Cart.json"),
                    new SpineAsset("Fs_Particles_well", "spine/Fs_Particles_well.json"),
                    new SpineAsset("GS_M1", "spine/GS_M1.json"),
                    new SpineAsset("GS_M2", "spine/M2_GS.json"),
                    new SpineAsset("GS_M3", "spine/M3_GS.json"),
                    new SpineAsset("GS_M4", "spine/M4_GS.json"),
                    new SpineAsset("GS_M5", "spine/M5_GS.json"),
                    new SpineAsset("FS_Goblin", "spine/FS_Goblin.json"),
                    new SpineAsset("E4_Shine", "spine/E4_Shine.json"),
                    new SpineAsset("E4_Blast", "spine/E4_Blast.json"),
                    new SpineAsset("S_GS_M1", "spine/S_GS_M1.json"),
                    new SpineAsset("S_GS_M2", "spine/S_M2_GS.json"),
                    new SpineAsset("S_GS_M3", "spine/S_M3_GS.json"),
                    new SpineAsset("S_GS_M4", "spine/S_M4_GS.json"),
                    new SpineAsset("S_GS_M5", "spine/S_M5_GS.json"),
                    new SpineAsset("E_4_M1", "spine/E_4_M1.json"),
                    new SpineAsset("E_4_M2", "spine/E_4_M2.json"),
                    new SpineAsset("E_4_M3", "spine/E_4_M3.json"),
                    new SpineAsset("E_4_M4", "spine/E_4_M4.json"),
                    new SpineAsset("E_4_M5", "spine/E_4_M5.json"),
                    new SpineAsset("Symbol_To_Skeleton", "spine/Symbol_To_Skeleton.json"),
                    new SpineAsset("DW_Shine", "spine/DW_Shine.json"),
                    new SpineAsset("Bomb_Multiplier", "spine/Bomb_Multiplier.json"),
                    new SpineAsset("fsIntro_super_4s", "spine/GoblinFeast_3s.json"),
                    new SpineAsset("fsIntro_super_3s", "spine/GoblinFeast_3s.json"),
                    new SpineAsset("fsIntro_normal_4s", "spine/FreshMeatSpin_4s.json"),
                    new SpineAsset("fsIntro_normal_3s", "spine/FreshMeatSpin_3s.json"),
                    new SpineAsset("fsIntro_super_4s_bomb", "spine/GoblinFeastExplosive_3s.json"),
                    new SpineAsset("fsIntro_super_3s_bomb", "spine/GoblinFeastExplosive_3s.json"),
                    new SpineAsset("fsIntro_normal_4s_bomb", "spine/ExplosiveFreshMeatSpin_4s.json"),
                    new SpineAsset("fsIntro_normal_3s_bomb", "spine/ExplosiveFreshMeatSpin_3s.json"),
                    new SpineAsset("luckydraw", "spine/luckydraw.json"),
                    new SpineAsset("XBombX2", "spine/XBombX2.json"),
                    new SpineAsset("E_4_M1_Idle", "spine/E_4_M1_idle.json"),
                    new SpineAsset("E_4_M2_Idle", "spine/E_4_M2_Idle.json"),
                    new SpineAsset("E_4_M3_Idle", "spine/E_4_M3_Idle.json"),
                    new SpineAsset("E_4_M4_Idle", "spine/E_4_M4_Idle.json"),
                    new SpineAsset("E_4_M5_Idle", "spine/E_4_M5_Idle.json"),
                    new SpineAsset("BW_01", "spine/BW_01.json"),
                    new SpineAsset("BW_02", "spine/BW_02.json"),
                    new SpineAsset("BW_03", "spine/BW_03.json"),
                    new SpineAsset("BW_04", "spine/BW_04.json"),
                    new SpineAsset("BW_05", "spine/BW_05.json"),
                    new SpineAsset("Big_Win_Transition", "spine/Big_Win_Transition.json"),
                    new SpineAsset("SFS", "spine/SFS.json"),
                    new SpineAsset("GS_Highlight", "spine/GS_Highlight.json"),
                    new SpineAsset("DW_GW_Multi", "spine/DW_GW_Multi.json"),
                    new SpineAsset("MaxCap", "spine/MaxCap.json"),
                    new SpineAsset("Maxcap_Goblin", "spine/Maxcap_Goblin.json"),
                    new SpineAsset("L_Longlivetheking", "spine/L_Longlivetheking.json"),
                    new SpineAsset("L_Thekingisdead", "spine/L_Thekingisdead.json"),
                    new SpineAsset("P_Thekingisdead", "spine/P_Thekingisdead.json"),
                    new SpineAsset("FMS_Anticipation", "spine/FMS_Anticipation.json"),
                    new SpineAsset("Maxcap_31969X", "spine/Maxcap_31969X.json"),
            ]
            },
            {
                //Keep at 32-bit color
                name : "symbol_l_bg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbol_l_bg0", "sheets/symbol_l_bg/symbol_l_bg0.json"),

                ],
                animations : {
                    "L1_size7_frame" : "78_L1_frame",
                    "L1_size6_frame" : "90_L1_frame",
                    "L1_size5_frame" : "108_L1_frame",
                    "L1_size4_frame" : "136_L1_frame",
                    "L1_size3_frame" : "181_L1_frame",
                    "L2_size7_frame" : "78_L2_frame",
                    "L2_size6_frame" : "90_L2_frame",
                    "L2_size5_frame" : "108_L2_frame",
                    "L2_size4_frame" : "136_L2_frame",
                    "L2_size3_frame" : "181_L2_frame",
                    "L3_size7_frame" : "78_L3_frame",
                    "L3_size6_frame" : "90_L3_frame",
                    "L3_size5_frame" : "108_L3_frame",
                    "L3_size4_frame" : "136_L3_frame",
                    "L3_size3_frame" : "181_L3_frame",
                    "L4_size7_frame" : "78_L4_frame",
                    "L4_size6_frame" : "90_L4_frame",
                    "L4_size5_frame" : "108_L4_frame",
                    "L4_size4_frame" : "136_L4_frame",
                    "L4_size3_frame" : "181_L4_frame",
                    "L5_size7_frame" : "78_L5_frame",
                    "L5_size6_frame" : "90_L5_frame",
                    "L5_size5_frame" : "108_L5_frame",
                    "L5_size4_frame" : "136_L5_frame",
                    "L5_size3_frame" : "181_L5_frame",
                }
            },{
                //Keep at 32-bit color
                name : "symbol_m_bg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("m_bg0", "sheets/m_bg/m_bg0.json"),

                ],
                animations : {
                    "M5_size3_frame":"M5/181_m5_frame",
                    "M5_size4_frame":"M5/136_m5_frame",
                    "M5_size5_frame":"M5/108_m5_frame",
                    "M5_size6_frame":"M5/90_m5_frame",
                    "M5_size7_frame":"M5/78_m5_frame",
                    "M4_size3_frame":"M4/181_m4_frame",
                    "M4_size4_frame":"M4/136_m4_frame",
                    "M4_size5_frame":"M4/108_m4_frame",
                    "M4_size6_frame":"M4/90_m4_frame",
                    "M4_size7_frame":"M4/78_m4_frame",
                    "M3_size3_frame":"M3/181_m3_frame",
                    "M3_size4_frame":"M3/136_m3_frame",
                    "M3_size5_frame":"M3/108_m3_frame",
                    "M3_size6_frame":"M3/90_m3_frame",
                    "M3_size7_frame":"M3/78_m3_frame",
                    "M2_size3_frame":"M2/181_m2_frame",
                    "M2_size4_frame":"M2/136_m2_frame",
                    "M2_size5_frame":"M2/108_m2_frame",
                    "M2_size6_frame":"M2/90_m2_frame",
                    "M2_size7_frame":"M2/78_m2_frame",
                    "M1_size3_frame":"M1/181_m1_frame",
                    "M1_size4_frame":"M1/136_m1_frame",
                    "M1_size5_frame":"M1/108_m1_frame",
                    "M1_size6_frame":"M1/90_m1_frame",
                    "M1_size7_frame":"M1/78_m1_frame",
                }
            },
            {
                //Keep at 32-bit color
                name : "symbol_h_bg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbol_h_bg0", "sheets/symbol_h_bg/symbol_h_bg0.json"),

                ],
                animations : {
                    "B_size7_frame" : "78_xbomb_frame",
                    "B_size6_frame" : "90_xbomb_frame",
                    "B_size5_frame" : "108_xbomb_frame",
                    "B_size4_frame" : "136_xbomb_frame",
                    "B_size3_frame" : "181_xbomb_frame",
                    "Z_size7_frame" : "78_z_frame",
                    "Z_size6_frame" : "90_z_frame",
                    "Z_size5_frame" : "108_z_frame",
                    "Z_size4_frame" : "136_z_frame",
                    "Z_size3_frame" : "181_z_frame",
                    "S_size7_frame" : "78_s_frame",
                    "S_size6_frame" : "90_s_frame",
                    "S_size5_frame" : "108_s_frame",
                    "S_size4_frame" : "136_s_frame",
                    "S_size3_frame" : "181_s_frame",
                }
            },
            {
                //Keep at 32-bit color
                name : "m1",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("m10", "sheets/m1/m10.json"),
                ],
                animations : {
                    "M1_3":"M1/M1_3",
                    "M1_4":"M1/M1_4",
                    "M1_5":"M1/M1_5",
                    "M1_6":"M1/M1_6",
                    "M1_7":"M1/M1_7",
                }
            },
            {
                //Keep at 32-bit color
                name : "m2",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("m20", "sheets/m2/m20.json"),
                ],
                animations : {
                    "M2_3":"M2/M2_3",
                    "M2_4":"M2/M2_4",
                    "M2_5":"M2/M2_5",
                    "M2_6":"M2/M2_6",
                    "M2_7":"M2/M2_7",
                }
            },
            {
                //Keep at 32-bit color
                name : "m3",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("m30", "sheets/m3/m30.json"),
                ],
                animations : {
                    "M3_3":"M3/M3_3",
                    "M3_4":"M3/M3_4",
                    "M3_5":"M3/M3_5",
                    "M3_6":"M3/M3_6",
                    "M3_7":"M3/M3_7",
                }
            },
            {
                //Keep at 32-bit color
                name : "m4",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("m40", "sheets/m4/m40.json"),
                ],
                animations : {
                    "M4_3":"M4/M4_3",
                    "M4_4":"M4/M4_4",
                    "M4_5":"M4/M4_5",
                    "M4_6":"M4/M4_6",
                    "M4_7":"M4/M4_7",
                }
            },
            {
                //Keep at 32-bit color
                name : "m5",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("m50", "sheets/m5/m50.json"),
                ],
                animations : {
                    "M5_3":"M5/M5_3",
                    "M5_4":"M5/M5_4",
                    "M5_5":"M5/M5_5",
                    "M5_6":"M5/M5_6",
                    "M5_7":"M5/M5_7",
                }
            },
            {
                //Keep at 32-bit color
                name : "spineAssets",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("spineAssets0", "sheets/spineAssets/spineAssets0.json"),
                ],
                animations : {
                    "S/S_top":"S_top",
                    "S/S_bg" :"S_bg",
                    "M1/M1_top":"M1_top",
                    "M1/M1_bg" :"M1_bg",
                    "M1/M1_frame" :"M1_frame",
                    "M2/M2_top":"M2_top",
                    "M2/M2_bg" :"M2_bg",
                    "M2/M2_frame" :"M2_frame",
                    "M3/M3_top":"M3_top",
                    "M3/M3_bg" :"M3_bg",
                    "M3/M3_frame" :"M3_frame",
                    "M4/M4_top":"M4_top",
                    "M4/M4_bg" :"M4_bg",
                    "M4/M4_frame" :"M4_frame",
                    "M5/M5_top":"M5_top",
                    "M5/M5_bg" :"M5_bg",
                    "M5/M5_frame" :"M5_frame",
                }
            },
            {
                //Keep at 32-bit color
                name : "bigwin",
                autoLoad : [AssetQualityLevel.MEDIUM,AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("bigwin0", "sheets/bigwin/bigwin0.json"),
                    new TextureAsset("bigwin1", "sheets/bigwin/bigwin1.json")
                ],
                animations : {}
            }
        ]
    };
}
